import React, {useEffect, useRef} from 'react';
import {Chart, ArcElement} from 'chart.js'

import {Bar} from "react-chartjs-2";
import {Doughnut} from 'react-chartjs-2';
import commaSeparator from "../../../utils/CommaSeparator";

Chart.register(ArcElement);

const AdminCharts = (props) => {
  const chartType = props.type
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.height = 100;
    }
  })

  console.log(props.title)
  // debugger
  return (

    <>
      {props.data
        ?

        <div className={props.className}>
          <div className={"text-center border border-black"}>{props.title}   {!isNaN(props.sum) && "| جمع کل:"+  commaSeparator(props.sum)}</div>
          {
            chartType === 'Bar' ?
              <div className={"border border-black"}>
                <Bar
                  ref={ref}
                  data={props.data}
                  options={props.options}
                  // style={{maxHeight: "50%",maxWidth: "15%"}}
                />
              </div>
              :
              chartType === 'Doughnut' ?
                <div className={"border border-black"}>
                  <Doughnut
                    ref={ref}
                    data={props.data}
                    options={props.options}
                    // style={{maxHeight: "50%",maxWidth: "15%"}}
                  />
                </div>
                :
                <div>نوع مشخص نشده</div>
          }
        </div>
        :
        <div className={props.className}>
           <div className={"text-center border border-black"}>{props.title}

           </div>
          <div className={"text-center border border-black py-3"}> داده ای موجود نیست</div>
        </div>
      }
    </>
  );
};

export default AdminCharts;
